import {
  PageContainer,
  PageHeaderProps,
  PageContainerProps,
  ProSkeleton,
} from "@ant-design/pro-components";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getDetailInfo } from "@api";
import PageTitle from "@/components/PageTitle";

export interface Prop extends PageContainerProps {
  children?: React.ReactNode;
  url: string;
  funcChildren?: (key: string, data: any) => React.ReactNode;
  headerCongif?: (key: string, data: any) => PageHeaderProps;
}

export default function CustomDetailPage(prop: Prop) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const { state, pathname, hash } = useLocation();
  const navigation = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState({ ...state });
  const BUILDIN = (
    prop.tabList && prop.tabList[0].key ? prop.tabList[0].key : ""
  ) as string;
  const [tabActiveKey, setTabActiveKey] = useState<string>(
    hash.split("?")[0] || BUILDIN
  );
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (!id) return;
    setLoading(true);
    getDetailInfo(`${prop.url}/${id}`)
      .then((res: any) => {
        setData(res.data.body);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [id, prop.url]);
  return (
    <div className="bg-[#f2f2f2] dark:bg-[#000] typeDetailCalss">
      <PageTitle title={`${t(prop.url)} ${data?.name}`} />
      <PageContainer
        {...prop}
        loading={
          loading && (
            <ProSkeleton
              type="descriptions"
              pageHeader={false}
              active={false}
            />
          )
        }
        tabActiveKey={tabActiveKey}
        onTabChange={(key) => {
          navigation(`${pathname}${key}`, { replace: true });
          setTabActiveKey(key);
        }}
        header={prop.headerCongif?.(tabActiveKey, data)}
      >
        {!loading && prop.funcChildren?.(tabActiveKey, data)}
        {!loading && prop.children}
      </PageContainer>
    </div>
  );
}
